import styled from 'styled-components';

const Style = styled.div`
  padding: 24px 0 !important;

  &.about {
    padding-bottom: 32px !important;
    margin-bottom: 32px;
    border-bottom: 1px solid var(--base-gray-30);
  }

  &.comment {
    margin-top: 44px;
    padding: 0px !important;

    label {
      color: var(--base-gray-70);
    }
  }

  .header-title {
    font-size: 18px;
    
    &.m-0 {
      margin: 0px;
    }
  }

  .header {
    display: flex;
    width: 100%;

    p {
      color: var(--base-gray-70);
      font-size: 16px;
      margin-bottom: 0px;
      margin-top: 12px;
      font-weight: 500;
    }

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .icon-c {
        svg, i {
          margin-left: 10px;
          color: var(--color-primary-70);
          width: 21px;
          height: 21px;
        }
      }

      span {
        font-size: 18px;
        font-weight: 700;
      }

      &.main {
        flex: 1;
        flex-direction: row;
        justify-content: flex-end;

        div {
          flex-direction: row;
          cursor: pointer;
        }

        svg {
          width: 17px;
          height: 17px;
          color: #c7c7c7;
          margin-top: 4px;
        }

        span {
          color: #c7c7c7;
          font-size: var(--font-size-lg);
          font-weight: 500;
        }
      }
    }
  }

  .body {
    p {
      margin-bottom: 0px;
      color: var(--base-gray-90);
      font-size: 14px;
      line-height: 22px;
    }
  }

  &.no-body-header {
    margin-bottom: 0px;
    border-bottom: 0px;
    padding-bottom: 0px !important;
  }
`;

export default Style;
